export default __webpack_public_path__ + "static/media/AmericanTourister1.bf507436.jpg";